(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219],{

/***/ 21387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2415);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var loadingContainer = {
  width: '4rem',
  height: '4rem',
  display: 'flex',
  justifyContent: 'space-around'
};
var loadingCircle = {
  display: 'block',
  width: '1rem',
  height: '1rem',
  backgroundColor: 'black',
  borderRadius: '50%'
};
var loadingContainerVariants = {
  start: {
    transition: {
      staggerChildren: 0.2
    }
  },
  end: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
var loadingCircleVariants = {
  start: {
    y: '50%'
  },
  end: {
    y: '150%'
  }
};
var loadingCircleTransition = {
  duration: 0.5,
  yoyo: Infinity,
  ease: 'easeInOut'
};

var LoadingDots = function LoadingDots() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    style: loadingContainer,
    variants: loadingContainerVariants,
    initial: "start",
    animate: "end",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.span */ .E.span, {
      style: loadingCircle,
      variants: loadingCircleVariants,
      transition: loadingCircleTransition
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.span */ .E.span, {
      style: loadingCircle,
      variants: loadingCircleVariants,
      transition: loadingCircleTransition
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.span */ .E.span, {
      style: loadingCircle,
      variants: loadingCircleVariants,
      transition: loadingCircleTransition
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LoadingDots);

/***/ }),

/***/ 34455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var MetaTags = function MetaTags(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Digito' : _ref$title,
      description = _ref.description,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'https://digito.se' : _ref$url,
      _ref$img = _ref.img,
      img = _ref$img === void 0 ? 'https://digito.se/share-pic.jpg' : _ref$img;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      itemProp: "name",
      content: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      itemProp: "description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      itemProp: "image",
      content: img
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:url",
      content: url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:title",
      content: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "og:image",
      content: img
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:title",
      content: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:description",
      content: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:image",
      content: img
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 97155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Modal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(18598);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 5 modules
var Modal_Modal = __webpack_require__(44987);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CloseButton.js



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var CloseBlackSvg = function CloseBlackSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M284.29 256L506.15 34.14c7.811-7.811 7.811-20.475 0-28.285s-20.475-7.811-28.285 0l-221.86 221.86L34.145 5.855c-7.811-7.811-20.475-7.811-28.285 0s-7.811 20.475 0 28.285L227.72 256 5.86 477.86c-7.811 7.811-7.811 20.475 0 28.285 3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857l221.86-221.86 221.86 221.86c3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857c7.811-7.811 7.811-20.475 0-28.285L284.292 256z"
    })
  }));
};

CloseBlackSvg.defaultProps = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloseWhiteSvg = function CloseWhiteSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M284.29 256L506.15 34.14c7.811-7.811 7.811-20.475 0-28.285s-20.475-7.811-28.285 0l-221.86 221.86L34.145 5.855c-7.811-7.811-20.475-7.811-28.285 0s-7.811 20.475 0 28.285L227.72 256 5.86 477.86c-7.811 7.811-7.811 20.475 0 28.285 3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857l221.86-221.86 221.86 221.86c3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857c7.811-7.811 7.811-20.475 0-28.285L284.292 256z"
    })
  }));
};

CloseWhiteSvg.defaultProps = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff"
};
var absoluteStyle = (0,emotion_react_browser_esm/* css */.iv)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  right: 10px;\n  top: 10px;\n"])));
var Button = emotion_styled_browser_esm/* default.button */.Z.button(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 6px;\n  ", "\n"])), function (_ref) {
  var absolute = _ref.absolute;
  return absolute && absoluteStyle;
});
var closeIconStyle = (0,emotion_react_browser_esm/* css */.iv)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 20px;\n  width: 20px;\n"])));
var CloseWhiteIcon = (0,emotion_styled_browser_esm/* default */.Z)(CloseWhiteSvg)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), closeIconStyle);
var CloseBlackIcon = (0,emotion_styled_browser_esm/* default */.Z)(CloseBlackSvg)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), closeIconStyle);

var CloseButton = function CloseButton(_ref2) {
  var _ref2$absolute = _ref2.absolute,
      absolute = _ref2$absolute === void 0 ? false : _ref2$absolute,
      _ref2$black = _ref2.black,
      black = _ref2$black === void 0 ? false : _ref2$black,
      onClick = _ref2.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button, {
    absolute: absolute,
    "aria-label": "close-button",
    onClick: onClick,
    children: black ? /*#__PURE__*/(0,jsx_runtime.jsx)(CloseBlackIcon, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(CloseWhiteIcon, {})
  });
};

/* harmony default export */ var components_CloseButton = (CloseButton);
;// CONCATENATED MODULE: ./src/components/Modal.js


var Modal_templateObject;






var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(Modal_templateObject || (Modal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: 50%;\n  margin: auto;\n  max-width: ", ";\n  padding: ", ";\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 95%;\n"])), function (_ref) {
  var theme = _ref.theme,
      customBackground = _ref.customBackground;
  return customBackground ? customBackground : theme.palette.WHITE;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.width.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.xxxxlarge, " ").concat(theme.space.medium);
});

var Modal = function Modal(_ref5) {
  var customBackground = _ref5.customBackground,
      open = _ref5.open,
      onClose = _ref5.onClose,
      children = _ref5.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
    style: {
      zIndex: 999
    },
    open: open,
    onClose: onClose,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      customBackground: customBackground,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_CloseButton, {
        absolute: true,
        onClick: onClose,
        black: !customBackground
      }), children]
    })
  });
};

/* harmony default export */ var components_Modal = (Modal);

/***/ }),

/***/ 41583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58365);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Skeleton = function Skeleton(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);

/***/ }),

/***/ 20626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2415);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _templateObject, _templateObject2;





var item = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1
  }
};
var LinkWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.a */ .E.a)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});
var Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.small;
});

var SocialMediaLinksIcon = function SocialMediaLinksIcon(_ref3) {
  var href = _ref3.href,
      icon = _ref3.icon,
      id = _ref3.id,
      onClick = _ref3.onClick;
  if (href) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkWrapper, {
    id: id,
    onClick: onClick,
    href: href,
    rel: "noopener noreferrer",
    target: "_blank",
    variants: item,
    whileHover: {
      scale: 1.1
    },
    children: icon
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    id: id,
    onClick: onClick,
    variants: item,
    whileHover: {
      scale: 1.1
    },
    children: icon
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SocialMediaLinksIcon);

/***/ }),

/***/ 11765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SE": function() { return /* binding */ useUserContext; },
/* harmony export */   "fS": function() { return /* binding */ UserContextProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var utils_getCleanUserObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88898);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var UserContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();

var UserContextProvider = function UserContextProvider(_ref) {
  var _user = _ref.user,
      children = _ref.children;
  var user = (0,utils_getCleanUserObject__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_user);
  var company = _user.company;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UserContext.Provider, {
    value: {
      user: user,
      company: company
    },
    children: children
  });
};

var useUserContext = function useUserContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(UserContext);
};


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UserContext)));

/***/ }),

/***/ 84296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(18598);
// EXTERNAL MODULE: ./src/components/LoadingDots.js
var LoadingDots = __webpack_require__(21387);
// EXTERNAL MODULE: ./src/components/MetaTags.js
var MetaTags = __webpack_require__(34455);
// EXTERNAL MODULE: ./src/contexts/UserContext.js
var UserContext = __webpack_require__(11765);
// EXTERNAL MODULE: ./src/components/Skeleton.js
var Skeleton = __webpack_require__(41583);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/map/MapSkeleton.js


var _templateObject;





var StyledSkeleton = (0,emotion_styled_browser_esm/* default */.Z)(Skeleton/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 300px;\n  border-radius: ", ";\n  box-shadow: ", ";\n  margin: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadiusM;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.boxShadowSmall, " ").concat(theme.palette.GRAY);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.xxlarge, " ").concat(theme.space.medium, " ").concat(theme.space.small);
});

var MapSkeleton = function MapSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSkeleton, {});
};

/* harmony default export */ var map_MapSkeleton = (MapSkeleton);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 178 modules
var motion = __webpack_require__(2415);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(42238);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./src/utils/tracking.js
var tracking = __webpack_require__(6864);
// EXTERNAL MODULE: ./src/components/socialMediaLinks/SocialMediaLinksIcon.js
var SocialMediaLinksIcon = __webpack_require__(20626);
;// CONCATENATED MODULE: ./src/components/socialMediaLinks/SocialMediaLinks.js



var SocialMediaLinks_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var FacebookSvg = function FacebookSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M2.707 24h8.804a.75.75 0 0 0 .75-.75l-.011-7a.75.75 0 0 0-.75-.75H9.25V13h2.25a.75.75 0 0 0 .75-.75V9.433A4.438 4.438 0 0 1 16.683 5h2.067v2.5H17.5c-.965 0-1.75.785-1.75 1.75v3c0 .414.336.75.75.75h3.04l-.625 2.5H16.5a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h4.793A2.71 2.71 0 0 0 24 21.293V2.707A2.71 2.71 0 0 0 21.293 0H2.707A2.71 2.71 0 0 0 0 2.707v18.587A2.71 2.71 0 0 0 2.707 24zM1.5 2.707c0-.666.541-1.207 1.207-1.207h18.587c.666 0 1.207.541 1.207 1.207v18.587c0 .666-.541 1.207-1.207 1.207H17.25V17h2.25a.75.75 0 0 0 .728-.568l1-4a.75.75 0 0 0-.728-.932h-3.25V9.25c0-.136.114-.25.25-.25h2a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75h-2.817a5.94 5.94 0 0 0-5.933 5.933V11.5H8.5a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h2.25v5.5H2.707A1.208 1.208 0 0 1 1.5 21.293z"
    })
  }));
};

FacebookSvg.defaultProps = {
  height: "512",
  viewBox: "0 0 24 24",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
};

var GithubSvg = function GithubSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M256 0C115.3 0 0 116.3 0 257c0 139.883 114.25 255 256 255 141.574 0 256-114.945 256-255C512 116.3 396.7 0 256 0zm45 477.5c-14.398 3-29.7 4.5-45 4.5s-30.602-1.5-45-4.5v-70.2c0-16.8 4.5-22.8 10.5-30.902 3.055-3.492 4.898-6.625 18.598-27.296L217 345.5c-59.402-8.7-82.8-39.602-92.102-63.602-12-32.097-5.699-72.3 15.903-97.796 3.3-3.903 6-10.504 3.601-17.403-4.504-13.8-3.902-35.699-.902-44.101 15.906 2.273 32.262 13.668 45.902 21.902 6.286 3.668 9.582 2.7 12.598 3 10.96-2.281 28.059-7.8 54.3-7.8 16.2 0 33.302 2.398 50.102 7.198 3.004-.07 7.832 2.485 16.2-2.398 14.257-8.687 30.058-19.691 45.898-21.902 3 8.402 3.602 30.3-.898 44.101-2.403 6.899.296 13.5 3.601 17.403 21.598 25.5 27.899 65.699 15.899 97.796-9.301 24-32.7 54.903-92.102 63.602l-23.098 3.602c14.16 21.367 15.653 23.93 18.602 27.296C296.5 384.5 301 390.5 301 407.301zm30-8.7v-61.5c0-17.1-3.602-28.5-8.402-36.902 45.601-12.296 78.004-39.3 92.402-78 15.3-40.796 8.402-89.398-17.102-123 4.504-20.097 4.504-52.199-6.296-67.199C386.8 95.602 380.199 92 371.8 92h-.301c-23.262 1.258-41.57 12.973-61.2 24.898-18-4.8-36.3-7.199-54.6-7.199-18.598 0-37.2 2.7-53.696 7.2C181.34 104.437 163.207 93.226 139.3 92c-7.5 0-14.102 3.602-18.903 10.2-10.796 15-10.796 47.1-6.296 67.198-25.504 33.602-32.403 82.5-17.102 123 14.398 38.7 46.8 65.704 92.402 78-3.722 6.512-6.668 14.915-7.828 26.286-9.21 3.175-17.199 4.21-24.629 2.027-7.836-2.316-13.941-7.547-19.246-16.469-11.914-20.015-32.207-36.355-55.312-34.23l2.636 29.883c10.7-.98 21.348 10.34 26.88 19.671 9.124 15.368 21.417 25.446 36.546 29.914 11.23 3.31 21.496 3.23 32.551.872V468.8C93.7 438.199 30 354.8 30 257 30 132.8 131.8 30 256 30s226 102.8 226 227c0 97.8-63.7 181.2-151 211.8zm0 0"
    })
  }));
};

GithubSvg.defaultProps = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
};

var InstagramSvg = function InstagramSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M75 512h362c41.355 0 75-33.645 75-75V75c0-41.355-33.645-75-75-75H75C33.645 0 0 33.645 0 75v362c0 41.355 33.645 75 75 75zM30 75c0-24.813 20.188-45 45-45h362c24.813 0 45 20.188 45 45v362c0 24.813-20.188 45-45 45H75c-24.813 0-45-20.188-45-45zm0 0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M256 391c74.438 0 135-60.563 135-135s-60.563-135-135-135-135 60.563-135 135 60.563 135 135 135zm0-240c57.898 0 105 47.102 105 105s-47.102 105-105 105-105-47.102-105-105 47.102-105 105-105zm0 0M406 151c24.813 0 45-20.188 45-45s-20.188-45-45-45-45 20.188-45 45 20.188 45 45 45zm0-60c8.27 0 15 6.73 15 15s-6.73 15-15 15-15-6.73-15-15 6.73-15 15-15zm0 0"
    })]
  }));
};

InstagramSvg.defaultProps = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
};

var LinkedInSvg = function LinkedInSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M151 181H91c-8.285 0-15 6.715-15 15v240c0 8.285 6.715 15 15 15h60c8.285 0 15-6.715 15-15V196c0-8.285-6.715-15-15-15zm-15 240h-30V211h30zm0 0M121 61c-24.813 0-45 20.188-45 45s20.188 45 45 45 45-20.188 45-45-20.188-45-45-45zm0 60c-8.27 0-15-6.73-15-15s6.73-15 15-15 15 6.73 15 15-6.73 15-15 15zm0 0M355.64 181.926c-24.507-3.977-49.593.687-69.738 12.34C285.04 186.796 278.695 181 271 181h-60c-8.285 0-15 6.715-15 15v240c0 8.285 6.715 15 15 15h60c8.285 0 15-6.715 15-15V301c0-16.543 13.457-30 30-30s30 13.457 30 30v135c0 8.285 6.715 15 15 15h60c8.285 0 15-6.715 15-15V274.54c0-44.798-31.66-84.712-80.36-92.614zM406 421h-30V301c0-33.086-26.914-60-60-60s-60 26.914-60 60v120h-30V211h30v15a15.006 15.006 0 0 0 9.262 13.86 15 15 0 0 0 16.343-3.255l6.997-6.996c14.726-14.722 39.156-21.816 62.234-18.07 35.309 5.73 55.164 33.945 55.164 63zm0 0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M436 0H76C34.516 0 0 34.543 0 76v360c0 41.484 34.543 76 76 76h360c41.484 0 76-34.543 76-76V76c0-41.484-34.543-76-76-76zm46 436c0 24.934-21.066 46-46 46H76c-24.934 0-46-21.066-46-46V76c0-24.934 21.066-46 46-46h360c24.934 0 46 21.066 46 46zm0 0"
    })]
  }));
};

LinkedInSvg.defaultProps = {
  height: "512pt",
  viewBox: "0 0 512 512",
  width: "512pt",
  xmlns: "http://www.w3.org/2000/svg"
};

var PinterestSvg = function PinterestSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25 2C12.309 2 2 12.309 2 25s10.309 23 23 23 23-10.309 23-23S37.691 2 25 2zm0 2c11.609 0 21 9.39 21 21s-9.39 21-21 21c-2.125 0-4.172-.316-6.106-.902.864-1.438 1.973-3.493 2.415-5.192.261-1.008 1.34-5.113 1.34-5.113.699 1.34 2.746 2.469 4.925 2.469 6.485 0 11.156-5.961 11.156-13.371 0-7.106-5.797-12.418-13.254-12.418-9.281 0-14.207 6.226-14.207 13.012 0 3.152 1.68 7.078 4.364 8.328.41.187.628.105.718-.285.074-.301.438-1.762.598-2.438.055-.219.027-.406-.149-.617-.886-1.082-1.601-3.062-1.601-4.906 0-4.746 3.594-9.332 9.71-9.332 5.282 0 8.977 3.598 8.977 8.746 0 5.816-2.933 9.848-6.757 9.848-2.11 0-3.688-1.746-3.184-3.887.61-2.559 1.781-5.316 1.781-7.16 0-1.653-.883-3.028-2.719-3.028-2.156 0-3.89 2.23-3.89 5.223 0 1.902.644 3.192.644 3.192s-2.132 9.007-2.523 10.688c-.39 1.675-.285 3.93-.125 5.613C9.422 41.353 4 33.822 4 25 4 13.393 13.39 4 25 4z"
    })
  }));
};

PinterestSvg.defaultProps = {
  viewBox: "0 0 50 50",
  xmlns: "http://www.w3.org/2000/svg"
};

var SnapchatSvg = function SnapchatSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.941 3.102c-5.422 0-9.84 4.418-9.84 9.84v54.116c0 5.422 4.418 9.84 9.84 9.84h54.117c5.422 0 9.84-4.418 9.84-9.84V12.941c0-5.422-4.418-9.84-9.84-9.84zm0 2.457h54.117a7.362 7.362 0 0 1 7.383 7.382v54.117a7.362 7.362 0 0 1-7.383 7.383H12.941a7.362 7.362 0 0 1-7.383-7.383V12.941a7.362 7.362 0 0 1 7.383-7.382zm0 3.691a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.918 0c-.676 0-1.23.55-1.23 1.23a1.23 1.23 0 1 0 1.23-1.23zm4.922 0a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0-2.46zm4.918 0c-.676 0-1.231.55-1.231 1.23a1.23 1.23 0 1 0 1.23-1.23zm-27.06 6.148c-4.101 0-8.402 2.004-11.257 5.532-2.41 2.976-3.59 7.132-2.762 11.883-1.59-.696-3.067-1.02-4.246-.575-1.778.668-2.645 2.434-2.645 4.07 0 .926.371 1.755.871 2.403.5.652 1.121 1.168 1.774 1.66 1.027.77 2.074 1.527 3.039 2.324-2.117 3.34-4.121 5.016-5.688 5.93-.863.504-1.61.824-2.3 1.293-.688.469-1.387 1.356-1.387 2.383 0 1.023.531 1.89 1.168 2.5.637.61 1.402 1.047 2.176 1.39 1.12.497 2.011.602 2.906.743.086.691.289 1.492 1.031 2.23 1.117 1.117 3.012 1.746 6.25 1.746 1.434 0 1.98.645 3.469 1.637 1.488.992 3.707 2.055 7.601 2.055s6.114-1.063 7.602-2.055c1.488-.992 2.035-1.637 3.469-1.637 3.238 0 5.133-.629 6.25-1.746.742-.738.945-1.539 1.031-2.23.895-.14 1.785-.246 2.906-.743.774-.343 1.54-.78 2.176-1.39.637-.61 1.168-1.477 1.168-2.5 0-1.027-.7-1.914-1.387-2.383-.691-.469-1.437-.789-2.3-1.293-1.567-.914-3.57-2.59-5.688-5.93.965-.796 2.012-1.554 3.04-2.324.651-.492 1.272-1.008 1.772-1.66.5-.648.872-1.477.872-2.402 0-1.637-.868-3.403-2.645-4.07-1.18-.446-2.656-.122-4.246.574.828-4.75-.352-8.907-2.762-11.883-2.855-3.528-7.156-5.532-11.258-5.532zm0 2.461c3.282 0 6.973 1.688 9.344 4.617 2.375 2.93 3.516 7.032 1.79 12.215a1.229 1.229 0 0 0 .445 1.387 1.237 1.237 0 0 0 1.46-.012c2.274-1.707 3.68-1.78 4.364-1.527.684.258 1.047.95 1.047 1.77 0 .308-.09.554-.36.906-.27.348-.722.754-1.3 1.184-1.149.863-2.754 1.816-4.13 3.19-.39.392-.472 1-.198 1.481 2.558 4.48 5.25 6.532 7.214 7.68.98.57 1.774.942 2.16 1.203.387.262.305.14.305.348 0 .203-.086.414-.41.726s-.867.645-1.473.915c-1.214.542-2.832.82-3.039.82-.68 0-1.23.55-1.23 1.226 0 .618.015 1.016-.407 1.438s-1.601 1.023-4.511 1.023c-2.254 0-3.555 1.2-4.832 2.051-1.281.856-2.754 1.64-6.239 1.64s-4.957-.784-6.238-1.64c-1.277-.851-2.578-2.05-4.832-2.05-2.91 0-4.09-.602-4.512-1.024s-.406-.82-.406-1.438a1.23 1.23 0 0 0-1.23-1.226c-.207 0-1.824-.278-3.04-.82-.605-.27-1.148-.602-1.472-.915s-.41-.523-.41-.726c0-.207-.082-.086.304-.348.387-.261 1.18-.633 2.16-1.203 1.965-1.148 4.657-3.2 7.215-7.68.274-.48.192-1.09-.199-1.48-1.375-1.375-2.98-2.328-4.129-3.191-.578-.43-1.03-.836-1.3-1.184-.27-.352-.36-.598-.36-.906 0-.82.363-1.512 1.047-1.77.684-.254 2.09-.18 4.363 1.527.434.32 1.024.329 1.461.012.434-.312.617-.875.446-1.387-1.727-5.183-.586-9.285 1.789-12.215 2.37-2.93 6.062-4.617 9.343-4.617zM12.942 68.29a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.921 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.918 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.922 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.918 0c-.676 0-1.23.551-1.23 1.23a1.23 1.23 0 1 0 1.23-1.23zm4.922 0a1.23 1.23 0 1 0 0 2.461 1.23 1.23 0 0 0 0-2.46zm4.918 0c-.676 0-1.23.551-1.23 1.23a1.23 1.23 0 1 0 1.23-1.23z"
    })
  }));
};

SnapchatSvg.defaultProps = {
  viewBox: "0 0 80 80",
  xmlns: "http://www.w3.org/2000/svg"
};

var SoundcloudSvg = function SoundcloudSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 686.216c0 13.014 4.718 22.854 14.152 29.524 9.435 6.669 19.52 9.027 30.256 7.076 10.085-1.952 17.161-5.531 21.229-10.736 4.066-5.205 6.1-13.827 6.1-25.864v-141.52c0-10.086-3.497-18.626-10.492-25.62-6.994-6.995-15.534-10.492-25.62-10.492-9.76 0-18.137 3.497-25.132 10.492C3.498 526.07 0 534.61 0 544.696v141.52zm112.24 60.512c0 9.436 3.335 16.511 10.004 21.229 6.67 4.718 15.21 7.076 25.62 7.076 10.736 0 19.438-2.359 26.108-7.076 6.669-4.717 10.004-11.793 10.004-21.229V416.84c0-9.76-3.498-18.138-10.492-25.132-6.995-6.994-15.535-10.492-25.62-10.492-9.76 0-18.138 3.498-25.132 10.492-6.995 6.995-10.492 15.372-10.492 25.132v329.888zm111.752 15.616c0 9.435 3.416 16.511 10.248 21.229 6.832 4.717 15.616 7.076 26.353 7.076 10.41 0 18.95-2.359 25.619-7.076 6.67-4.718 10.005-11.794 10.005-21.229V461.248c0-10.085-3.498-18.707-10.492-25.864-6.995-7.157-15.372-10.735-25.132-10.735-10.086 0-18.707 3.578-25.864 10.735s-10.736 15.779-10.736 25.864v301.096zm112.24 1.464c0 17.894 12.037 26.841 36.112 26.841 24.074 0 36.111-8.947 36.111-26.841v-488c0-27.328-8.296-42.781-24.888-46.36-10.736-2.603-21.31.488-31.72 9.272-10.411 8.784-15.616 21.146-15.616 37.088v488zm114.193 14.152V247.016c0-16.917 5.042-27.002 15.128-30.256 21.797-5.205 43.432-7.808 64.904-7.808 49.775 0 96.136 11.712 139.079 35.136 42.944 23.424 77.674 55.388 104.188 95.892 26.515 40.505 41.887 85.156 46.116 133.957 19.845-8.459 40.991-12.688 63.439-12.688 45.547 0 84.506 16.104 116.876 48.312 32.371 32.209 48.557 70.923 48.557 116.145 0 45.547-16.186 84.424-48.557 116.632-32.37 32.208-71.166 48.312-116.388 48.312l-424.56-.488c-2.929-.976-5.125-2.766-6.589-5.368s-2.193-4.882-2.193-6.834z"
    })
  }));
};

SoundcloudSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2500",
  height: "1387",
  viewBox: "0 208.952 1048.713 581.696"
};

var SpotifySvg = function SpotifySvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.24 1.09c-6.02 0-10.908 4.888-10.908 10.909S6.22 22.908 12.24 22.908c6.021 0 10.909-4.888 10.909-10.909S18.261 1.09 12.24 1.09zm0 1.8c5.027 0 9.109 4.082 9.109 9.109s-4.082 9.109-9.109 9.109-9.108-4.082-9.108-9.109S7.213 2.89 12.24 2.89zM7.411 16.315s5.061-1.379 8.664.919a.9.9 0 0 0 .968-1.517c-4.202-2.68-10.096-1.141-10.096-1.141a.9.9 0 1 0 .464 1.739zm.066-3.186s4.525-1.556 9.725 1.156a.9.9 0 0 0 .833-1.596c-5.96-3.107-11.154-1.258-11.154-1.258a.9.9 0 0 0 .596 1.698zm-.709-3.222s5.505-1.727 11.747 1.184a.9.9 0 0 0 .761-1.631C12.343 6.226 6.224 8.191 6.224 8.191a.9.9 0 0 0 .544 1.716z"
    })]
  }));
};

SpotifySvg.defaultProps = {
  clipRule: "evenodd",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: "2",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TiktokSvg = function TiktokSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M41 4H9C6.243 4 4 6.243 4 9v32c0 2.757 2.243 5 5 5h32c2.757 0 5-2.243 5-5V9c0-2.757-2.243-5-5-5m-3.994 18.323a7.482 7.482 0 0 1-.69.035 7.492 7.492 0 0 1-6.269-3.388v11.537a8.527 8.527 0 1 1-8.527-8.527c.178 0 .352.016.527.027v4.202c-.175-.021-.347-.053-.527-.053a4.351 4.351 0 1 0 0 8.704c2.404 0 4.527-1.894 4.527-4.298l.042-19.594h4.02a7.488 7.488 0 0 0 6.901 6.685v4.67"
    })
  }));
};

TiktokSvg.defaultProps = {
  viewBox: "4 4 42 42",
  xmlns: "http://www.w3.org/2000/svg",
  width: "2500",
  height: "2500"
};

var TwitterSvg = function TwitterSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M365.008 0H130.992C57.536 0 0 57.536 0 130.992v234.016C0 438.464 57.536 496 130.992 496h234.016C438.464 496 496 438.464 496 365.008V130.992C496 57.536 438.448 0 365.008 0zM464 365.008c0 55.52-43.488 98.992-98.992 98.992H130.992C75.488 464 32 420.512 32 365.008V130.992C32 75.488 75.488 32 130.992 32h234.016C420.528 32 464 75.488 464 130.992v234.016z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M403.984 126.64c-5.136-3.76-12.016-4.08-17.504-.88-5.472 3.216-17.6 4.8-27.328 6.08-2.016.272-4 .528-5.92.8-13.616-11.296-31.008-17.632-48.944-17.632-40.4 0-73.552 31.264-75.904 70.592-36.64-6.176-70.192-25.28-93.968-53.984-3.536-4.288-9.024-6.384-14.56-5.664a15.973 15.973 0 0 0-12.432 9.424c-1.024 2.336-9.952 24.304-9.952 78.64 0 47.056 37.136 81.632 62.608 99.824-17.424 7.92-37.504 10.832-56.576 8.72-7.456-.8-14.432 3.584-16.896 10.608A16.017 16.017 0 0 0 93.168 352c30.08 18.976 64.848 29.008 100.56 29.008 114.688 0 184.096-90.096 186.672-178.928 3.296-4.784 9.584-14.096 20.208-30.432 4.256-6.576 7.824-20.752 9.568-28.608 1.392-6.208-1.056-12.656-6.192-16.4zm-52.448 60.896a16.036 16.036 0 0 0-3.04 9.376c0 63.152-48.016 152.096-154.752 152.096-9.648 0-19.216-.88-28.592-2.608 12.512-4.736 24.336-11.344 35.2-19.712 4.352-3.344 6.672-8.72 6.16-14.176a15.98 15.98 0 0 0-8.704-12.768c-.688-.352-68.32-35.92-68.32-85.712 0-16.688.896-29.808 2.08-39.792 31.408 27.04 71.376 43.216 113.44 45.296.32.016.656.032.96.016 9.312-.272 16.16-7.104 16.16-16 0-2.208-.448-4.304-1.264-6.224-.4-2.4-.608-4.816-.608-7.232 0-23.76 19.744-43.088 44.032-43.088 12.192 0 23.92 4.992 32.192 13.68 3.776 3.936 9.296 5.712 14.624 4.672 3.632-.688 7.824-1.232 12.224-1.808 1.568-.208 3.152-.416 4.768-.64-12.016 18.304-16.352 24.336-16.56 24.624z"
    })]
  }));
};

TwitterSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 496 496"
};

var YoutubeSvg = function YoutubeSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M229.763 25.817c-2.699-10.162-10.65-18.165-20.747-20.881C190.716 0 117.333 0 117.333 0S43.951 0 25.651 4.936C15.554 7.652 7.602 15.655 4.904 25.817 0 44.237 0 82.667 0 82.667s0 38.43 4.904 56.85c2.698 10.162 10.65 18.164 20.747 20.881 18.3 4.935 91.682 4.935 91.682 4.935s73.383 0 91.683-4.935c10.097-2.717 18.048-10.72 20.747-20.88 4.904-18.422 4.904-56.851 4.904-56.851s0-38.43-4.904-56.85"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M93.333 117.56l61.334-34.89-61.334-34.893z",
      fill: "#fff"
    })]
  }));
};

YoutubeSvg.defaultProps = {
  width: "1200",
  height: "800",
  viewBox: "-35.2 -41.333 305.07 248",
  xmlns: "http://www.w3.org/2000/svg"
};




var iconStyle = function iconStyle(_ref) {
  var theme = _ref.theme;
  return (0,emotion_react_browser_esm/* css */.iv)(SocialMediaLinks_templateObject || (SocialMediaLinks_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  width: auto;\n"])), theme.iconHeight.large);
};

var LinkedInIcon = (0,emotion_styled_browser_esm/* default */.Z)(LinkedInSvg)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var InstagramIcon = (0,emotion_styled_browser_esm/* default */.Z)(InstagramSvg)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var FacebookIcon = (0,emotion_styled_browser_esm/* default */.Z)(FacebookSvg)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var TwitterIcon = (0,emotion_styled_browser_esm/* default */.Z)(TwitterSvg)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var GithubIcon = (0,emotion_styled_browser_esm/* default */.Z)(GithubSvg)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var PinterestIcon = (0,emotion_styled_browser_esm/* default */.Z)(PinterestSvg)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var SnapchatIcon = (0,emotion_styled_browser_esm/* default */.Z)(SnapchatSvg)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var YoutubeIcon = (0,emotion_styled_browser_esm/* default */.Z)(YoutubeSvg)(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var SpotifyIcon = (0,emotion_styled_browser_esm/* default */.Z)(SpotifySvg)(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var TiktokIcon = (0,emotion_styled_browser_esm/* default */.Z)(TiktokSvg)(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), iconStyle);
var SoundcloudIcon = (0,emotion_styled_browser_esm/* default */.Z)(SoundcloudSvg)(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  height: 25px;\n"])), iconStyle);
var container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
var Wrapper = (0,emotion_styled_browser_esm/* default */.Z)(motion/* motion.div */.E.div)(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  border-radius: ", ";\n  border: ", ";\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadiusM;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "2px solid ".concat(theme.palette.DARK_GRAY);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.xlarge, " ").concat(theme.space.large, " 0");
});

var getSocialMediaIcon = function getSocialMediaIcon(name) {
  switch (name) {
    case 'linkedin':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkedInIcon, {});

    case 'instagram':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(InstagramIcon, {});

    case 'facebook':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FacebookIcon, {});

    case 'twitter':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TwitterIcon, {});

    case 'github':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(GithubIcon, {});

    case 'pinterest':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PinterestIcon, {});

    case 'snapchat':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SnapchatIcon, {});

    case 'youtube':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(YoutubeIcon, {});

    case 'spotify':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SpotifyIcon, {});

    case 'tiktok':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TiktokIcon, {});

    case 'soundcloud':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SoundcloudIcon, {});

    default:
      return null;
  }
};

var SocialMediaLinks = function SocialMediaLinks() {
  var _useRouter = (0,next_router.useRouter)(),
      slug = _useRouter.query.slug;

  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      _useUserContext$user = _useUserContext.user,
      accountlvl = _useUserContext$user.accountlvl,
      socialMediaLinks = _useUserContext$user.socialMediaLinks;

  var ua = new (ua_parser_default())();

  if (socialMediaLinks.length < 1) {
    return null;
  }

  var handleClick = function handleClick(sm) {
    return (0,tracking/* default */.Z)({
      condition: accountlvl > 1,
      payload: {
        type: 'social_media_link',
        slug: slug,
        name: sm.name
      },
      ua: ua,
      callback: function callback() {
        return window.open(sm.url, '_blank');
      },
      secondaryCallback: function secondaryCallback() {
        return window.location.href = sm.url;
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    animate: "show",
    initial: "hidden",
    variants: container,
    children: socialMediaLinks.map(function (sm) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLinksIcon/* default */.Z, {
        id: sm.name,
        onClick: function onClick() {
          return handleClick(sm);
        },
        icon: getSocialMediaIcon(sm.name)
      }, sm.name);
    })
  });
};

/* harmony default export */ var socialMediaLinks_SocialMediaLinks = (SocialMediaLinks);
// EXTERNAL MODULE: ./src/layout/Layout.js + 3 modules
var Layout = __webpack_require__(84255);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/utils/formatPhoneNumber.js
var formatPhoneNumber = function formatPhoneNumber(nbr) {
  var cleaned = ('' + nbr).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);

  if (match) {
    return "".concat(match[1], "-").concat(match[2], " ").concat(match[3], " ").concat(match[4]);
  }

  return nbr;
};

/* harmony default export */ var utils_formatPhoneNumber = (formatPhoneNumber);
;// CONCATENATED MODULE: ./src/utils/getCleanUrl.js
var getCleanUrl = function getCleanUrl(url) {
  var urlObj = new URL(url);
  return urlObj.hostname;
};

/* harmony default export */ var utils_getCleanUrl = (getCleanUrl);
;// CONCATENATED MODULE: ./src/features/publicProfile/components/ContactInfoCard.js



var ContactInfoCard_templateObject, ContactInfoCard_templateObject2, ContactInfoCard_templateObject3, ContactInfoCard_templateObject4, ContactInfoCard_templateObject5, ContactInfoCard_templateObject6, ContactInfoCard_templateObject7, ContactInfoCard_templateObject8;

function ContactInfoCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ContactInfoCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ContactInfoCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContactInfoCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var EnvelopeSvg = function EnvelopeSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ContactInfoCard_objectSpread(ContactInfoCard_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M467 61H45C20.218 61 0 81.196 0 106v300c0 24.72 20.128 45 45 45h422c24.72 0 45-20.128 45-45V106c0-24.72-20.128-45-45-45zm-6.214 30L256.954 294.833 51.36 91h409.427zM30 399.788V112.07l144.48 143.24L30 399.788zM51.213 421l144.57-144.57 50.657 50.222c5.864 5.814 15.327 5.795 21.167-.046L317 277.213 460.787 421H51.213zM482 399.787L338.213 256 482 112.212v287.575z"
    })
  }));
};

EnvelopeSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  fill: "#fff"
};

var MonitorSvg = function MonitorSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ContactInfoCard_objectSpread(ContactInfoCard_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M422.2 24.5H59.4C26.7 24.5 0 51.1 0 83.9V314c0 32.7 26.6 59.4 59.4 59.4h167.9v56.7h-83.7c-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5H338c7.5 0 13.5-6 13.5-13.5s-6-13.5-13.5-13.5h-83.7v-56.7h167.9c32.7 0 59.4-26.6 59.4-59.4V83.9c0-32.8-26.6-59.4-59.4-59.4zm-362.8 27h362.9c17.8 0 32.4 14.5 32.4 32.4v192.3H27V83.9C27 66 41.5 51.5 59.4 51.5zm362.8 294.9H59.4C41.6 346.4 27 331.9 27 314v-10.8h427.6V314c0 17.8-14.5 32.4-32.4 32.4z"
    })
  }));
};

MonitorSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 481.6 481.6",
  fill: "#fff"
};

var PhoneSvg = function PhoneSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ContactInfoCard_objectSpread(ContactInfoCard_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M498.827 377.633l-63.65-63.65c-17.548-17.547-46.102-17.547-63.65 0l-28.93 28.93c-13.294 13.294-34.926 13.3-48.215.005l-125.4-125.507c-13.325-13.325-13.327-34.892 0-48.22l28.93-28.93c17.47-17.47 17.715-45.935-.017-63.665l-63.632-63.432C116.717-4.38 88.164-4.38 70.663 13.12L47.47 36.11c-63.28 63.28-63.28 166.242-.003 229.52L246.16 464.426c63.428 63.43 166.088 63.434 229.52 0l23.146-23.145c17.548-17.548 17.548-46.1 0-63.648zM91.833 34.382c5.85-5.85 15.365-5.85 21.233.016l63.632 63.432c5.863 5.863 5.863 15.352 0 21.216l-10.61 10.608-84.8-84.8 10.554-10.462zm175.547 408.83L68.687 244.415C19.73 195.457 17.038 118.582 60.41 66.41l84.564 84.564c-22.22 25.19-21.294 63.572 2.787 87.653l125.396 125.5c24.06 24.06 62.44 25.046 87.66 2.796l84.566 84.566c-52.007 43.298-128.71 41.02-178.004-8.276zm210.232-23.148l-10.61 10.61-84.865-84.866 10.607-10.608c5.85-5.85 15.367-5.85 21.217 0l63.65 63.65c5.85 5.85 5.85 15.368.001 21.216z"
    })
  }));
};

PhoneSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 511.999 511.999",
  fill: "#fff"
};
var ContactInfoCard_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(ContactInfoCard_templateObject || (ContactInfoCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: flex;\n  justify-content: center;\n  margin: ", ";\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.WHITE;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadiusM;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.boxShadowSmall, " ").concat(theme.palette.GRAY);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.xxlarge, " ").concat(theme.space.medium, " ").concat(theme.space.small);
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.large, " ").concat(theme.space.xsmall);
});
var ContentWrapper = emotion_styled_browser_esm/* default.div */.Z.div(ContactInfoCard_templateObject2 || (ContactInfoCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n"])));
var Row = emotion_styled_browser_esm/* default.div */.Z.div(ContactInfoCard_templateObject3 || (ContactInfoCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  display: flex;\n  padding: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.xsmall, " 0");
});

var ContactInfoCard_iconStyle = function iconStyle(_ref7) {
  var theme = _ref7.theme;
  return (0,emotion_react_browser_esm/* css */.iv)(ContactInfoCard_templateObject4 || (ContactInfoCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  margin: ", ";\n  fill: ", ";\n"])), theme.iconHeight.small, "0 ".concat(theme.space.xsmall), theme.palette.BLACK);
};

var EnvelopeIcon = (0,emotion_styled_browser_esm/* default */.Z)(EnvelopeSvg)(ContactInfoCard_templateObject5 || (ContactInfoCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), ContactInfoCard_iconStyle);
var PhoneIcon = (0,emotion_styled_browser_esm/* default */.Z)(PhoneSvg)(ContactInfoCard_templateObject6 || (ContactInfoCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), ContactInfoCard_iconStyle);
var MonitorIcon = (0,emotion_styled_browser_esm/* default */.Z)(MonitorSvg)(ContactInfoCard_templateObject7 || (ContactInfoCard_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), ContactInfoCard_iconStyle);
var A = emotion_styled_browser_esm/* default.a */.Z.a(ContactInfoCard_templateObject8 || (ContactInfoCard_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.BLACK;
});

var ContactInfoCard = function ContactInfoCard() {
  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      _useUserContext$user = _useUserContext.user,
      email = _useUserContext$user.email,
      phoneNumber = _useUserContext$user.phoneNumber,
      companyPage = _useUserContext$user.companyPage;

  if (!email && !phoneNumber && !companyPage) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ContactInfoCard_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentWrapper, {
      children: [email && /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EnvelopeIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(A, {
          href: "mailto:".concat(email),
          children: email
        })]
      }), phoneNumber && /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PhoneIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(A, {
          href: "tel:".concat(phoneNumber),
          children: utils_formatPhoneNumber(phoneNumber)
        })]
      }), companyPage && /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MonitorIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(A, {
          href: companyPage,
          rel: 'noopener noreferrer',
          target: '_blank',
          children: utils_getCleanUrl(companyPage)
        })]
      })]
    })
  });
};

/* harmony default export */ var components_ContactInfoCard = (/*#__PURE__*/(0,react.memo)(ContactInfoCard));
// EXTERNAL MODULE: ./src/components/typography/index.js + 5 modules
var typography = __webpack_require__(50677);
// EXTERNAL MODULE: ./node_modules/cloudinary-react/dist/cloudinary-react.esm.js
var cloudinary_react_esm = __webpack_require__(42736);
;// CONCATENATED MODULE: ./src/components/Image.js


var Image_templateObject, Image_templateObject2;





var Image_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(Image_templateObject || (Image_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 50%;\n  height: ", ";\n  overflow: hidden;\n  padding-bottom: ", ";\n  position: relative;\n  width: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.imgSize.small;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.imgSize.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.imgSize.small;
});
var StyledImage = (0,emotion_styled_browser_esm/* default */.Z)(cloudinary_react_esm/* Image */.Ee)(Image_templateObject2 || (Image_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"])));

var ImageComponent = function ImageComponent(_ref4) {
  var src = _ref4.src;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Image_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImage, {
      publicId: src,
      alt: "profile-img",
      secure: "true",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(cloudinary_react_esm/* Transformation */.zA, {
        quality: "auto",
        fetchFormat: "auto"
      })
    })
  });
};

/* harmony default export */ var Image = (ImageComponent);
// EXTERNAL MODULE: ./src/components/header/Logo.js
var Logo = __webpack_require__(48061);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(7878);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 1 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(30511);
// EXTERNAL MODULE: ./src/components/Modal.js + 1 modules
var Modal = __webpack_require__(97155);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var esm = __webpack_require__(84059);
;// CONCATENATED MODULE: ./src/features/publicProfile/components/QrModal.js


var QrModal_templateObject, QrModal_templateObject2, QrModal_templateObject3, QrModal_templateObject4;














var textStyling = function textStyling(_ref) {
  var theme = _ref.theme;
  return (0,emotion_react_browser_esm/* css */.iv)(QrModal_templateObject || (QrModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  text-align: center;\n"])), theme.palette.WHITE);
};

var StyledH2 = (0,emotion_styled_browser_esm/* default */.Z)(typography.H2)(QrModal_templateObject2 || (QrModal_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), textStyling);
var StyledP = (0,emotion_styled_browser_esm/* default */.Z)(typography.P)(QrModal_templateObject3 || (QrModal_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), textStyling);
var QRWrapper = emotion_styled_browser_esm/* default.div */.Z.div(QrModal_templateObject4 || (QrModal_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  margin: ", ";\n  width: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.WHITE;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.width.xxxsmall;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.xxlarge, " auto");
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.width.xxxsmall;
});

var QrModal = function QrModal(_ref6) {
  var open = _ref6.open,
      closeModal = _ref6.closeModal;

  var _useRouter = (0,next_router.useRouter)(),
      asPath = _useRouter.asPath;

  var _useTheme = (0,emotion_element_cbed451f_browser_esm.a)(),
      palette = _useTheme.palette;

  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      company = _useUserContext.company;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    open: open,
    onClose: closeModal,
    customBackground: (company === null || company === void 0 ? void 0 : company.color) || palette.GREEN,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledH2, {
        children: "Scanna QR-kod f\xF6r att se profil."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(QRWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.ZP, {
          value: "".concat(config/* default.HOST */.Z.HOST).concat(asPath)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledP, {
        children: "Anv\xE4nd din telefons kamera och skanna QR-koden ovan f\xF6r att \xF6ppna digito-kortet."
      })]
    })
  });
};

/* harmony default export */ var components_QrModal = (QrModal);
;// CONCATENATED MODULE: ./src/features/publicProfile/components/HeroHeader.js



var HeroHeader_templateObject, HeroHeader_templateObject2, HeroHeader_templateObject3, HeroHeader_templateObject4, HeroHeader_templateObject5;

function HeroHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HeroHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HeroHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeroHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var QrSvg = function QrSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", HeroHeader_objectSpread(HeroHeader_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M256 60v40h-40V60zm-40 235v57h40v-57zm120 217v-40h-40v-40h-40v80zm80-297H296v40h120zm0 80h56v-40h-56zm0 57v40h96v-97h-40v57zM296 0h-40v60h40zm-40 180h40v-80h-40v40h-40v115h40zM0 215v80h40v-40h60v-40zm296 80v-40h-40v40zm80 40h40v-40h-40zm96-80h40v-40h-40zm-136 40h-40v57h-40v40h80zM216 432h40v-40h-40zm120-40v40h80v-40zm120 80v-40h-40v40zm56 40v-40h-56v40zm-136 0h40v-40h-40zM180 255v-40h-40v40h-40v40h116v-40zm0-75H0V0h180zM140 40H40v100h100zm-30 30H70v40h40zM512 0v180H332V0zm-40 40H372v100h100zm-30 30h-40v40h40zM0 332h180v180H0zm40 140h100V372H40zm30-30h40v-40H70zm0 0"
    })
  }));
};

QrSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "682.667",
  viewBox: "0 0 512 512",
  width: "682.667",
  fill: "currentcolor"
};




var HeroHeader_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(HeroHeader_templateObject || (HeroHeader_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: ", ";\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.space.xsmall;
});
var ImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(HeroHeader_templateObject2 || (HeroHeader_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var HeroHeader_StyledImage = (0,emotion_styled_browser_esm/* default */.Z)(cloudinary_react_esm/* Image */.Ee)(HeroHeader_templateObject3 || (HeroHeader_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 8px;\n  max-height: 45px;\n  max-width: 100%;\n  position: relative;\n  z-index: 10;\n"])));
var QRButton = emotion_styled_browser_esm/* default.button */.Z.button(HeroHeader_templateObject4 || (HeroHeader_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  border: none;\n  border-radius: 50%;\n  box-shadow: ", ";\n  height: 45px;\n  cursor: pointer;\n  padding: ", ";\n  width: 45px;\n"])), function (_ref2) {
  var theme = _ref2.theme,
      companyColor = _ref2.companyColor;
  return companyColor ? companyColor : theme.palette.GREEN;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "2px 2px 6px 0px ".concat(theme.palette.DARK_GRAY);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.xsmall;
});
var QrIcon = (0,emotion_styled_browser_esm/* default */.Z)(QrSvg)(HeroHeader_templateObject5 || (HeroHeader_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n  width: 100%;\n  fill: white;\n  padding: 2px;\n"])));

var HeroHeader = function HeroHeader() {
  var _useState = (0,react.useState)(false),
      qrModal = _useState[0],
      setQrModal = _useState[1];

  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      company = _useUserContext.company;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeroHeader_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: function onClick() {
          return window.open((company === null || company === void 0 ? void 0 : company.logoLink) || config/* default.HOST */.Z.HOST);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapper, {
          children: company !== null && company !== void 0 && company.logoId ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeroHeader_StyledImage, {
            publicId: company.logoId,
            secure: "true",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(cloudinary_react_esm/* Transformation */.zA, {
              quality: "auto",
              fetchFormat: "auto"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {
            black: true,
            large: true
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(QRButton, {
        "aria-label": "QR-code-button",
        companyColor: company === null || company === void 0 ? void 0 : company.color,
        onClick: function onClick() {
          return setQrModal(true);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(QrIcon, {})
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_QrModal, {
      open: qrModal,
      closeModal: function closeModal() {
        return setQrModal(false);
      }
    })]
  });
};

/* harmony default export */ var components_HeroHeader = (/*#__PURE__*/(0,react.memo)(HeroHeader));
;// CONCATENATED MODULE: ./src/features/publicProfile/components/Hero.js


var Hero_templateObject, Hero_templateObject2, Hero_templateObject3, Hero_templateObject4;










var Hero_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(Hero_templateObject || (Hero_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  border-bottom-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      companyColor = _ref.companyColor;
  return companyColor ? companyColor : theme.palette.GREEN;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.WHITE;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadiusXL;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadiusXL;
});
var Hero_StyledH2 = (0,emotion_styled_browser_esm/* default */.Z)(typography.H2)(Hero_templateObject2 || (Hero_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: 100;\n  margin-bottom: ", ";\n  text-align: center;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.xxsmall;
});
var StyledH3 = (0,emotion_styled_browser_esm/* default */.Z)(typography.H3)(Hero_templateObject3 || (Hero_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 0;\n  text-align: center;\n"])));
var Column = emotion_styled_browser_esm/* default.div */.Z.div(Hero_templateObject4 || (Hero_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.large, " ").concat(theme.space.xsmall);
});

var Hero = function Hero() {
  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      _useUserContext$user = _useUserContext.user,
      profilePicId = _useUserContext$user.profilePicId,
      firstName = _useUserContext$user.firstName,
      lastName = _useUserContext$user.lastName,
      jobTitle = _useUserContext$user.jobTitle,
      company = _useUserContext.company;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Hero_Wrapper, {
      companyColor: company === null || company === void 0 ? void 0 : company.color,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_HeroHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
        children: [profilePicId && /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: profilePicId,
          alt: "profilePic"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero_StyledH2, {
          children: "".concat(firstName, " ").concat(lastName)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledH3, {
          children: jobTitle
        })]
      })]
    })
  });
};

/* harmony default export */ var components_Hero = (/*#__PURE__*/(0,react.memo)(Hero));
;// CONCATENATED MODULE: ./src/components/LinksSection.Link.js


var LinksSection_Link_templateObject;








var item = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1
  }
};
var StyledA = (0,emotion_styled_browser_esm/* default */.Z)(motion/* motion.a */.E.a)(LinksSection_Link_templateObject || (LinksSection_Link_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: inherit;\n  display: flex;\n  justify-content: center;\n  margin-top: ", ";\n  &:first-child {\n    margin-top: 0px;\n  }\n  padding: ", ";\n  text-decoration: none;\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.WHITE;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadiusM;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.boxShadowSmall, " ").concat(theme.palette.GRAY);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.xsmall;
});

var LinksSection = function LinksSection(_ref6) {
  var t = _ref6.t,
      v = _ref6.v,
      i = _ref6.i,
      trackClick = _ref6.trackClick;

  var _useRouter = (0,next_router.useRouter)(),
      slug = _useRouter.query.slug;

  var ua = new (ua_parser_default())();

  var handleClick = function handleClick() {
    return (0,tracking/* default */.Z)({
      condition: trackClick,
      payload: {
        type: 'custom_link',
        slug: slug,
        index: i
      },
      ua: ua,
      callback: function callback() {
        return window.open(v, '_blank');
      },
      secondaryCallback: function secondaryCallback() {
        return window.location.href = v;
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledA, {
    onClick: handleClick,
    variants: item,
    whileHover: {
      scale: 1.1
    },
    children: t
  });
};

/* harmony default export */ var LinksSection_Link = (LinksSection);
;// CONCATENATED MODULE: ./src/features/publicProfile/components/LinksSection.js



var LinksSection_templateObject;

function LinksSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LinksSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LinksSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LinksSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LinksSection_Wrapper = (0,emotion_styled_browser_esm/* default */.Z)(motion/* motion.div */.E.div)(LinksSection_templateObject || (LinksSection_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: ", ";\n  display: flex;\n  flex-direction: column;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.space.xxlarge, " ").concat(theme.space.medium, " ").concat(theme.space.small);
});
var LinksSection_container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

var LinksSection_LinksSection = function LinksSection() {
  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      _useUserContext$user = _useUserContext.user,
      accountlvl = _useUserContext$user.accountlvl,
      links = _useUserContext$user.links;

  if (links.length < 1) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinksSection_Wrapper, {
    animate: "show",
    initial: "hidden",
    variants: LinksSection_container,
    children: links.map(function (p, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LinksSection_Link, LinksSection_objectSpread(LinksSection_objectSpread({}, p), {}, {
        trackClick: accountlvl > 1
      }), "link-".concat(i));
    })
  });
};

/* harmony default export */ var components_LinksSection = (LinksSection_LinksSection);
;// CONCATENATED MODULE: ./src/components/button/ButtonSkeleton.js


var ButtonSkeleton_templateObject;





var ButtonSkeleton_StyledSkeleton = (0,emotion_styled_browser_esm/* default */.Z)(Skeleton/* default */.Z)(ButtonSkeleton_templateObject || (ButtonSkeleton_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return "0 ".concat(theme.space.small);
});

var ButtonSkeleton = function ButtonSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonSkeleton_StyledSkeleton, {
    width: "110px",
    height: "35px"
  });
};

/* harmony default export */ var button_ButtonSkeleton = (ButtonSkeleton);
;// CONCATENATED MODULE: ./src/features/publicProfile/components/SaveContactSection.js


var SaveContactSection_templateObject;








var ShareContactButton = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 921).then(__webpack_require__.bind(__webpack_require__, 22921));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(button_ButtonSkeleton, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22921)];
    }
  }
});
var SaveContactButton = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(606), __webpack_require__.e(287)]).then(__webpack_require__.bind(__webpack_require__, 42783));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(button_ButtonSkeleton, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(42783)];
    }
  }
});
var ButtonWrapper = emotion_styled_browser_esm/* default.div */.Z.div(SaveContactSection_templateObject || (SaveContactSection_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  background: ", ";\n  bottom: 0;\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  z-index: 9999;\n"])), function (_ref) {
  var theme = _ref.theme,
      companyColor = _ref.companyColor;
  return companyColor ? companyColor : theme.palette.GREEN;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.borderRadiusXL, " ").concat(theme.borderRadiusXL, " 0px 0px");
});

var SaveContactSection = function SaveContactSection() {
  var _useUserContext = (0,UserContext/* useUserContext */.SE)(),
      company = _useUserContext.company;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonWrapper, {
    companyColor: company === null || company === void 0 ? void 0 : company.color,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShareContactButton, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SaveContactButton, {})]
  });
};

/* harmony default export */ var components_SaveContactSection = (SaveContactSection);
;// CONCATENATED MODULE: ./src/features/publicProfile/PublicProfile.js


var PublicProfile_templateObject;














var CompanyBio = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 51).then(__webpack_require__.bind(__webpack_require__, 51));
}, {
  ssr: false,
  loading: function loading() {
    return null;
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(51)];
    }
  }
});
var CompanyMapLeafLet = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(484), __webpack_require__.e(929)]).then(__webpack_require__.bind(__webpack_require__, 32929));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(map_MapSkeleton, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(32929)];
    }
  }
});
var PublicProfile_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(PublicProfile_templateObject || (PublicProfile_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: auto;\n  max-width: ", ";\n  padding-bottom: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.width.xsmall;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xxxxlarge;
});

var PublicProfile = function PublicProfile() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Hero, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      backgroundColor: '#f4f4f4',
      fullHeight: false,
      header: false,
      toppPadding: '0px',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PublicProfile_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_ContactInfoCard, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(socialMediaLinks_SocialMediaLinks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinksSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyBio, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyMapLeafLet, {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_SaveContactSection, {})]
  });
};

/* harmony default export */ var publicProfile_PublicProfile = (PublicProfile);
;// CONCATENATED MODULE: ./src/pages/[slug].js


var _slug_templateObject;











var LoadingWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_slug_templateObject || (_slug_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n"])));

var PublicProfilePage = function PublicProfilePage(_ref) {
  var user = _ref.user,
      notFound = _ref.notFound;
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (notFound) {
      router.push('/404');
    }
  }, []);

  if (router.isFallback) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingDots/* default */.Z, {})
    });
  }

  if (!user) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
      title: "@".concat(user.slug),
      description: "Hantera och dela dina sociala kanaler p\xE5 en och samma plattform",
      url: "https://digito.se/".concat(user.slug)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UserContext/* UserContextProvider */.fS, {
      user: user,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(publicProfile_PublicProfile, {})
    })]
  });
};

PublicProfilePage.layoutOptions = {
  noLayout: true
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PublicProfilePage);

/***/ }),

/***/ 88898:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getCleanUserObject = function getCleanUserObject(user) {
  return {
    slug: user.slug || '',
    fb_id: user.fb_id || '',
    email: user.email || '',
    profilePicId: user.profilePicId || '',
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    jobTitle: user.jobTitle || '',
    phoneNumber: user.phoneNumber || '',
    companyPage: user.companyPage || '',
    socialMediaLinks: (user === null || user === void 0 ? void 0 : user.socialMediaLinks.map(function (_ref) {
      var name = _ref.name,
          url = _ref.url;
      return {
        name: name,
        url: url
      };
    })) || [],
    links: user.links || [],
    companiesAccess: user.companiesAccess || [],
    accountlvl: user.accountlvl || '',
    sessionId: user.sessionId || '',
    stats: user.stats || {},
    paymentData: user.paymentData || {}
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getCleanUserObject);

/***/ }),

/***/ 6864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72506);



var ASYNC_TRACK_BROWSERS = ['facebook', 'instagram'];

var track = /*#__PURE__*/function () {
  var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var _ua$getBrowser, _ua$getBrowser$name;

    var _ref$asyncTrack, asyncTrack, condition, payload, ua, callback, secondaryCallback;

    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$asyncTrack = _ref.asyncTrack, asyncTrack = _ref$asyncTrack === void 0 ? true : _ref$asyncTrack, condition = _ref.condition, payload = _ref.payload, ua = _ref.ua, callback = _ref.callback, secondaryCallback = _ref.secondaryCallback;

            if (!(asyncTrack && ASYNC_TRACK_BROWSERS.includes(ua === null || ua === void 0 ? void 0 : (_ua$getBrowser = ua.getBrowser()) === null || _ua$getBrowser === void 0 ? void 0 : (_ua$getBrowser$name = _ua$getBrowser.name) === null || _ua$getBrowser$name === void 0 ? void 0 : _ua$getBrowser$name.toLowerCase()))) {
              _context.next = 8;
              break;
            }

            if (!condition) {
              _context.next = 5;
              break;
            }

            _context.next = 5;
            return (0,api__WEBPACK_IMPORTED_MODULE_1__/* .userTracking */ .nc)(payload);

          case 5:
            secondaryCallback();
            _context.next = 10;
            break;

          case 8:
            if (condition) (0,api__WEBPACK_IMPORTED_MODULE_1__/* .userTracking */ .nc)(payload);
            callback();

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function track(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (track);

/***/ }),

/***/ 75332:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(84296);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [415,987,767,774,888,179], function() { return __webpack_exec__(75332); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);